import React from 'react';
import { LoginState } from './types/LoginState';
import { StyledCartExpiryCounter } from './tray/cartIcon.styles';
import { getReadableTime } from './hooks/useExpiryTime';

interface Props {
    isCartOverlayActive: boolean;
    loginState?: LoginState;
    isCartExpired: boolean;
    timeLeft: number | undefined;
    isOneCartDataFetching?: boolean;
    isClubHeaderInBellaCart: boolean;
}

const CartExpiryCounter = ({
    loginState,
    isCartOverlayActive = false,
    isCartExpired,
    timeLeft,
    isOneCartDataFetching,
    isClubHeaderInBellaCart,
}: Props) => {
    if (!(loginState?.isLoggedIn || loginState?.isPartiallyLoggedIn) || !timeLeft || isOneCartDataFetching) {
        return null;
    }
    return (
        <StyledCartExpiryCounter
            data-testid={`cart-counter-${isCartExpired ? 'expired' : 'active'}`}
            $isCartExpired={isCartExpired}
            $isCartOverlayActive={isCartOverlayActive}
            $isClubHeaderInBellaCart={isClubHeaderInBellaCart}
        >
            {getReadableTime(timeLeft)}
        </StyledCartExpiryCounter>
    );
};

export default CartExpiryCounter;
